// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import { BasketRow } from '../../styled-components/shared';
import Checkbox from '../Checkbox';

const BankerBadge = styled.div`
  display: inline-block;
  padding: 0.25em;
`;

type BasketCardSystemContentProps = {
  banker: boolean;
  handleSelectBanker: (...params: unknown) => unknown;
  readOnly: boolean;
};

const BasketCardSystemContent = ({ banker, handleSelectBanker, readOnly }: BasketCardSystemContentProps) => {
  return (
    <BasketRow $systemBaseRow>
      <>
        {readOnly && banker ? <BankerBadge>{__('Base')}</BankerBadge> : null}
        {!readOnly ? (
          <Checkbox onCheckChange={handleSelectBanker} checked={banker}>
            {__('Base')}
          </Checkbox>
        ) : null}
      </>
    </BasketRow>
  );
};

export default React.memo<BasketCardSystemContentProps>(BasketCardSystemContent);
